import React from 'react';
import classNames from 'classnames';
import styles from 'src/components/icons/Icons.module.scss';

const IconCheckTick = ({ className, ...props }) => (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" className={classNames(className, styles.svg)} {...props}>
        <path fillRule="evenodd" clipRule="evenodd"
            d="M4.68993 9.61262L1.6642 6.58688L0 8.25108L3.99339 12.2445L3.99766 12.2402L4.72659 12.9691L16 1.69574L14.3043 0L4.68993 9.61262Z"
            fill="white"/>
    </svg>

);

export default IconCheckTick;
